module.exports = __webpack_public_path__ + "static/media/adminDashboard.4bca754e.svg";